import UserAddressName from "./UserAddressName";
import UserAddressLink from "./UserAddressLink";


import UserName from "../../../../auth/components/user/UserDetail/UserName";
import UserLink from "../../../../auth/components/user/UserDetail/UserLink";

import AddressName from "../../../../address/components/address/AddressDetail/AddressName";
import AddressLink from "../../../../address/components/address/AddressDetail/AddressLink";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserAddressDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="UserAddress-detail-title"
                    >
                        { label || t`User Address` }: <UserAddressName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="UserAddress-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="UserAddress-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="userId-label"><Trans>User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="userId-value" >{ data.userId ? (<UserLink id={ data.userId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="addressId-label"><Trans>Address</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="addressId-value" >{ data.addressId ? (<AddressLink id={ data.addressId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default UserAddressDetail;
